const orbPath = filename => `${process.env.PUBLIC_URL}/orbs/${filename}`;

export const blockByOrb = {
  dawn: {
    key: 'early-morning',
    mood: 'Early Morning',
    orb: 'dawn',
    className: 'mood-early-morning',
    image: orbPath('orb-warm-dawn.png'),
    colours: {
      ink: '#2f2926',
      muted: '#7a6d61',
      panel: 'rgba(255, 251, 244, 0.48)',
      panelStrong: 'rgba(255, 251, 244, 0.72)',
      line: 'rgba(170, 128, 94, 0.2)',
      orbCore: 'rgba(255, 255, 255, 0.94)',
      orbMid: 'rgba(255, 213, 165, 0.86)',
      orbEdge: 'rgba(214, 143, 104, 0.68)',
      orbGlow: 'rgba(214, 153, 111, 0.24)',
      orbGlowFocus: 'rgba(235, 194, 112, 0.38)',
      orbGlowActive: 'rgba(235, 194, 112, 0.46)',
      backgroundTint: 'linear-gradient(145deg, #F7E9D8 0%, #f4e6d4 54%, #eadfd5 100%)',
      atmosphere: 'rgba(235, 194, 112, 0.24)',
      atmosphereGold: 'rgba(255, 214, 138, 0.2)',
      atmosphereX: '24%',
      atmosphereY: '18%',
      atmosphereSize: '30rem',
      grain: '0.1',
      grainLight: 'rgba(255, 238, 205, 0.58)',
      grainDark: 'rgba(120, 78, 45, 0.26)',
      button: '#7a5540',
      buttonHover: '#5d3f30',
    },
  },
  neutral: {
    key: 'afternoon',
    mood: 'Afternoon',
    orb: 'neutral',
    className: 'mood-afternoon',
    image: orbPath('orb-neutral.png'),
    colours: {
      ink: '#27302d',
      muted: '#66716c',
      panel: 'rgba(255, 255, 255, 0.44)',
      panelStrong: 'rgba(255, 255, 255, 0.66)',
      line: 'rgba(64, 76, 70, 0.18)',
      orbCore: 'rgba(255, 255, 255, 0.92)',
      orbMid: 'rgba(236, 230, 224, 0.86)',
      orbEdge: 'rgba(167, 183, 195, 0.72)',
      orbGlow: 'rgba(255, 250, 235, 0.42)',
      orbGlowFocus: 'rgba(255, 250, 235, 0.58)',
      orbGlowActive: 'rgba(255, 250, 235, 0.68)',
      backgroundTint: 'linear-gradient(145deg, #DDD8D0 0%, #d3d1cc 52%, #c8cbc8 100%)',
      atmosphere: 'rgba(255, 252, 235, 0.5)',
      atmosphereGold: 'rgba(244, 196, 108, 0.34)',
      atmosphereX: '16%',
      atmosphereY: '13%',
      atmosphereSize: '48rem',
      grain: '0.08',
      grainLight: 'rgba(255, 255, 248, 0.46)',
      grainDark: 'rgba(70, 68, 64, 0.16)',
      button: '#314e47',
      buttonHover: '#243b36',
    },
  },
  warm: {
    key: 'evening',
    mood: 'Evening',
    orb: 'warm',
    className: 'mood-evening',
    image: orbPath('orb-autumn-ember.png'),
    colours: {
      ink: '#302826',
      muted: '#76645f',
      panel: 'rgba(255, 250, 245, 0.42)',
      panelStrong: 'rgba(255, 250, 245, 0.66)',
      line: 'rgba(157, 96, 111, 0.18)',
      orbCore: 'rgba(255, 255, 255, 0.92)',
      orbMid: 'rgba(246, 186, 135, 0.84)',
      orbEdge: 'rgba(157, 96, 111, 0.7)',
      orbGlow: 'rgba(229, 151, 72, 0.3)',
      orbGlowFocus: 'rgba(229, 151, 72, 0.46)',
      orbGlowActive: 'rgba(229, 151, 72, 0.56)',
      backgroundTint: 'linear-gradient(145deg, #E8C4A8 0%, #dcb89c 50%, #cfae9f 100%)',
      atmosphere: 'rgba(229, 151, 72, 0.3)',
      atmosphereGold: 'rgba(255, 183, 93, 0.2)',
      atmosphereX: '20%',
      atmosphereY: '18%',
      atmosphereSize: '32rem',
      grain: '0.12',
      grainLight: 'rgba(255, 220, 184, 0.52)',
      grainDark: 'rgba(112, 57, 39, 0.3)',
      button: '#7b4a45',
      buttonHover: '#603832',
    },
  },
  night: {
    key: 'night',
    mood: 'Night',
    orb: 'night',
    className: 'mood-night',
    image: orbPath('todays-rooms-orb-night.png'),
    colours: {
      ink: '#e9eee9',
      muted: '#b8c3bd',
      panel: 'rgba(255, 255, 255, 0.12)',
      panelStrong: 'rgba(255, 255, 255, 0.2)',
      line: 'rgba(238, 244, 239, 0.18)',
      orbCore: 'rgba(245, 248, 244, 0.88)',
      orbMid: 'rgba(111, 126, 184, 0.74)',
      orbEdge: 'rgba(29, 34, 68, 0.78)',
      orbGlow: 'rgba(152, 184, 230, 0.28)',
      orbGlowFocus: 'rgba(152, 184, 230, 0.44)',
      orbGlowActive: 'rgba(152, 184, 230, 0.54)',
      backgroundTint: 'linear-gradient(145deg, #1E2336 0%, #252a3f 50%, #30334a 100%)',
      atmosphere: 'rgba(152, 184, 230, 0.22)',
      atmosphereGold: 'rgba(255, 224, 168, 0.08)',
      atmosphereX: '22%',
      atmosphereY: '14%',
      atmosphereSize: '34rem',
      grain: '0.1',
      grainLight: 'rgba(205, 224, 255, 0.34)',
      grainDark: 'rgba(11, 16, 31, 0.42)',
      button: '#dce7df',
      buttonHover: '#ffffff',
    },
  },
  midnight: {
    key: 'deep-night',
    mood: 'Deep Night',
    orb: 'midnight',
    className: 'mood-deep-night',
    image: orbPath('orb-midnight-glow.png'),
    colours: {
      ink: '#edf2ef',
      muted: '#bcc8c4',
      panel: 'rgba(255, 255, 255, 0.1)',
      panelStrong: 'rgba(255, 255, 255, 0.18)',
      line: 'rgba(238, 244, 239, 0.16)',
      orbCore: 'rgba(248, 250, 250, 0.9)',
      orbMid: 'rgba(102, 124, 218, 0.68)',
      orbEdge: 'rgba(36, 43, 96, 0.76)',
      orbGlow: 'rgba(151, 117, 214, 0.32)',
      orbGlowFocus: 'rgba(151, 117, 214, 0.48)',
      orbGlowActive: 'rgba(151, 117, 214, 0.58)',
      backgroundTint: 'linear-gradient(145deg, #0F1320 0%, #15192a 52%, #1f2134 100%)',
      atmosphere: 'rgba(151, 117, 214, 0.24)',
      atmosphereGold: 'rgba(255, 224, 168, 0.05)',
      atmosphereX: '20%',
      atmosphereY: '12%',
      atmosphereSize: '36rem',
      grain: '0.18',
      grainLight: 'rgba(192, 180, 255, 0.3)',
      grainDark: 'rgba(4, 7, 18, 0.5)',
      button: '#dce4ef',
      buttonHover: '#ffffff',
    },
  },
};

export const getSeasonalMoodBlock = (date = new Date()) => {
  const hour = date.getHours();

  if (hour >= 5 && hour < 11) {
    return blockByOrb.dawn;
  }

  if (hour >= 11 && hour < 17) {
    return blockByOrb.neutral;
  }

  if (hour >= 17 && hour < 21) {
    return blockByOrb.warm;
  }

  if (hour >= 21 || hour < 1) {
    return blockByOrb.night;
  }

  return blockByOrb.midnight;
};

export const getMoodStyle = block => ({
  '--ink': block.colours.ink,
  '--muted': block.colours.muted,
  '--panel': block.colours.panel,
  '--panel-strong': block.colours.panelStrong,
  '--line': block.colours.line,
  '--orb-core': block.colours.orbCore,
  '--orb-mid': block.colours.orbMid,
  '--orb-edge': block.colours.orbEdge,
  '--orb-glow': block.colours.orbGlow,
  '--orb-glow-focus': block.colours.orbGlowFocus,
  '--orb-glow-active': block.colours.orbGlowActive,
  '--background-tint': block.colours.backgroundTint,
  '--atmosphere': block.colours.atmosphere,
  '--atmosphere-gold': block.colours.atmosphereGold,
  '--atmosphere-x': block.colours.atmosphereX,
  '--atmosphere-y': block.colours.atmosphereY,
  '--atmosphere-size': block.colours.atmosphereSize,
  '--grain-opacity': block.colours.grain,
  '--grain-light': block.colours.grainLight,
  '--grain-dark': block.colours.grainDark,
  '--button': block.colours.button,
  '--button-hover': block.colours.buttonHover,
  '--orb-image': `url("${block.image}")`,
});
